import { serializeUrlSearchParams } from "@seamapi/url-search-params-serializer"
import defaultAxios, {
  type AxiosInstance,
  type CreateAxiosDefaults,
} from "axios"

/**
 * Create an axios instance for talking to a Seam API.
 *
 * Query parameters are serialized with `@seamapi/url-search-params-serializer`,
 * which defines how Seam API consumers must encode non-string parameters.
 * Axios' own serializer disagrees with it in ways the Seam API cannot parse:
 * arrays become `foo[]=1&foo[]=2` instead of `foo=1&foo=2`, and nested objects
 * are bracketed instead of dot-pathed. `@seamapi/http` configures the same
 * serializer internally, so this keeps hand-rolled clients consistent with
 * the SDK.
 *
 * A `paramsSerializer` passed in `config` is intentionally ignored: enforcing
 * Seam's serializer is the entire point of this factory. Use `axios.create`
 * directly for a client that must serialize some other way.
 *
 * Prefer this over `axios.create` for any client pointed at a Seam API.
 */
export const createSeamAxios = (
  config: CreateAxiosDefaults = {},
): AxiosInstance =>
  defaultAxios.create({
    ...config,
    paramsSerializer: serializeUrlSearchParams,
  })
